export default __webpack_public_path__ + "assets/models/da455b789aabbdf43d9e64487150e410.glb";